(function () {
  function getScrollStep(container) {
    const item = container.querySelector('.product-sales-v4__card');
    if (!item) return 0;
    const styles = window.getComputedStyle(container);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return item.offsetWidth + gap;
  }

  function getVisibleCount(container) {
    const cards = container.querySelectorAll('.product-sales-v4__card');
    if (!cards.length) return 1;

    const styles = window.getComputedStyle(container);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const containerWidth = container.clientWidth;
    let used = -gap;
    let visible = 0;

    for (let i = 0; i < cards.length; i++) {
      used += gap + cards[i].offsetWidth;
      if (used <= containerWidth + 1) {
        visible += 1;
      } else {
        break;
      }
    }

    return Math.max(1, visible);
  }

  function getPageCount(container) {
    const total = container.querySelectorAll('.product-sales-v4__card').length;
    if (total <= 1) return 1;

    const visible = getVisibleCount(container);
    return Math.max(1, total - visible + 1);
  }

  function getActiveIndex(container) {
    const step = getScrollStep(container);
    if (step <= 0) return 0;
    return Math.round(container.scrollLeft / step);
  }

  function getActivePage(container, pageCount) {
    if (pageCount <= 1) return 0;

    const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
    if (container.scrollLeft >= maxScroll - 1) return pageCount - 1;

    const visible = getVisibleCount(container);
    const total = container.querySelectorAll('.product-sales-v4__card').length;
    const maxStart = Math.max(0, total - visible);
    return Math.min(getActiveIndex(container), maxStart);
  }

  function canScrollX(container) {
    return getPageCount(container) > 1;
  }

  function updateProgress(container, root) {
    const progress = root.querySelector('.product-sales-v4__progress');
    const segments = root.querySelectorAll('.product-sales-v4__progress-segment');
    if (!segments.length) return;

    const pageCount = getPageCount(container);
    const needsNav = pageCount > 1;
    if (progress) {
      progress.hidden = !needsNav;
      progress.classList.toggle('is-complete', !needsNav);
    }
    if (!needsNav) return;

    const activePage = getActivePage(container, pageCount);
    segments.forEach((segment, index) => {
      const show = index < pageCount;
      segment.hidden = !show;
      segment.classList.toggle('is-active', show && index === activePage);
    });
  }

  function initSection(root) {
    const container = root.querySelector('[data-ps-v4-scroll]');
    const segments = root.querySelectorAll('.product-sales-v4__progress-segment');
    if (!container || !segments.length) return;

    const scrollToPage = (pageIndex) => {
      const step = getScrollStep(container);
      if (step <= 0) return;

      const pageCount = getPageCount(container);
      const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
      const next =
        pageIndex >= pageCount - 1 ? maxScroll : Math.min(Math.max(0, pageIndex * step), maxScroll);

      container.scrollTo({ left: next, behavior: 'smooth' });
    };

    const onScroll = () => updateProgress(container, root);

    container.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    segments.forEach((segment) => {
      segment.addEventListener('click', () => {
        const index = Number(segment.dataset.slideIndex);
        if (Number.isNaN(index)) return;
        scrollToPage(index);
      });
    });

    onScroll();
    requestAnimationFrame(onScroll);
  }

  function boot() {
    document.querySelectorAll('[data-ps-v4]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-ps-v4]');
    if (root) initSection(root);
  });
})();
